import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { usePathname } from 'next/navigation';
import { buildNetworkSwitchUrl } from '@/components/AppShell/networkRoutes';
import { useAsyncRoutePush } from '@/hooks/utils/useAsyncRouterPush';
import { mutationWithFeedback, showWarning } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
export function useHandleDeletion(currentViewId, currentNetworkId, refetchViews) {
  const $ = _c(10);
  const asyncPush = useAsyncRoutePush();
  const currentUrl = usePathname() ?? "";
  const {
    mutateAsync: deleteView,
    isPending: isPendingDelete
  } = trpc.view.deleteView.useMutation();
  let t0;
  if ($[0] !== asyncPush || $[1] !== currentNetworkId || $[2] !== currentUrl || $[3] !== currentViewId || $[4] !== deleteView || $[5] !== refetchViews) {
    t0 = async viewId => {
      await mutationWithFeedback({
        mutation: deleteView({
          viewId
        }),
        successText: "Deleted view!",
        errorText: "Failed to delete view!"
      });
      if (currentViewId === viewId) {
        const destination = buildNetworkSwitchUrl(currentUrl, currentNetworkId);
        if (destination) {
          await asyncPush(destination);
        }
        showWarning("View deleted", {
          description: "The selected view has been deleted."
        });
      }
      await refetchViews();
    };
    $[0] = asyncPush;
    $[1] = currentNetworkId;
    $[2] = currentUrl;
    $[3] = currentViewId;
    $[4] = deleteView;
    $[5] = refetchViews;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const handleDeletion = t0;
  let t1;
  if ($[7] !== handleDeletion || $[8] !== isPendingDelete) {
    t1 = {
      handleDeletion,
      isPendingDelete
    };
    $[7] = handleDeletion;
    $[8] = isPendingDelete;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}